 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_FRONTCOVERIMG from '@/components/01_frontcoverimg'
 import A2_TITLEIMG from '@/components/02_titleimg'
 import A3_COPYRIGHT from '@/components/03_copyright'
 import A4_CONTENT from '@/components/04_content'
 import A5_INTRODUCTION from '@/components/05_introduction'
 import A6_CH10 from '@/components/06_ch10'
 import A6_CH11 from '@/components/06_ch11'
 import A6_CH12 from '@/components/06_ch12'
 import A6_CH13 from '@/components/06_ch13'
 import A6_CH14 from '@/components/06_ch14'
 import A6_CH15 from '@/components/06_ch15'
 import A6_CH16 from '@/components/06_ch16'
 import A7_CH21 from '@/components/07_ch21'
 import A8_CH31 from '@/components/08_ch31'
 import A8_CH32 from '@/components/08_ch32'
 import A8_CH33 from '@/components/08_ch33'
 import A9_CH41 from '@/components/09_ch41'
 import A9_CH42 from '@/components/09_ch42'
 import A9_CH43 from '@/components/09_ch43'
 import A0_CH51 from '@/components/10_ch51'
 import A0_CH52 from '@/components/10_ch52'
 import A0_CH53 from '@/components/10_ch53'
 import A1_CH61 from '@/components/11_ch61'
 import A1_CH62 from '@/components/11_ch62'
 import A1_CH63 from '@/components/11_ch63'
 import A1_CH64 from '@/components/11_ch64'
 import A1_CH65 from '@/components/11_ch65'
 import A2_CH71 from '@/components/12_ch71'
 import A2_CH72 from '@/components/12_ch72'
 import A2_CH73 from '@/components/12_ch73'
 import A3_CH81 from '@/components/13_ch81'
 import A3_CH82 from '@/components/13_ch82'
 import A3_CH83 from '@/components/13_ch83'
 import A3_CH84 from '@/components/13_ch84'
 import A3_CH85 from '@/components/13_ch85'
 import A4_CH91 from '@/components/14_ch91'
 import A4_CH92 from '@/components/14_ch92'
 import A4_CH93 from '@/components/14_ch93'
 import A4_CH94 from '@/components/14_ch94'
 import A4_CH95 from '@/components/14_ch95'
 import A5_CH101 from '@/components/15_ch101'
 import A5_CH102 from '@/components/15_ch102'
 import A5_CH103 from '@/components/15_ch103'
 import A6_CH111 from '@/components/16_ch111'
 import A7_CH121 from '@/components/17_ch121'
 import A7_CH122 from '@/components/17_ch122'
 import A7_CH123 from '@/components/17_ch123'
 import A7_CH124 from '@/components/17_ch124'
 import A7_CH125 from '@/components/17_ch125'
 import A8_CH131 from '@/components/18_ch131'
 import A9_CH141 from '@/components/19_ch141'
 import A0_CH151 from '@/components/20_ch151'
 import A1_CH161 from '@/components/21_ch161'
 import A2_CH171 from '@/components/22_ch171'
 import A3_CH181 from '@/components/23_ch181'
 import A3_CH182 from '@/components/23_ch182'
 import A3_CH183 from '@/components/23_ch183'
 import A4_CH191 from '@/components/24_ch191'
 import A4_CH192 from '@/components/24_ch192'
 import A4_CH193 from '@/components/24_ch193'
 import A5_CH201 from '@/components/25_ch201'
 import A5_CH202 from '@/components/25_ch202'
 import A5_CH203 from '@/components/25_ch203'
 import A6_CH211 from '@/components/26_ch211'
 import A7_CH221 from '@/components/27_ch221'
 import A8_CH231 from '@/components/28_ch231'
 import A9_CH241 from '@/components/29_ch241'
 import A0_CH251 from '@/components/30_ch251'
 import A1_CH261 from '@/components/31_ch261'
 import A1_CH262 from '@/components/31_ch262'
 import A1_CH263 from '@/components/31_ch263'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/04_content",
 			"name" : "04_content",
 			"component" : A4_CONTENT
 		},
 		{
 			"path" : "/05_introduction",
 			"name" : "05_introduction",
 			"component" : A5_INTRODUCTION
 		},
 		{
 			"path" : "/06_ch10",
 			"name" : "06_ch10",
 			"component" : A6_CH10
 		},
 		{
 			"path" : "/06_ch11",
 			"name" : "06_ch11",
 			"component" : A6_CH11
 		},
 		{
 			"path" : "/06_ch12",
 			"name" : "06_ch12",
 			"component" : A6_CH12
 		},
 		{
 			"path" : "/06_ch13",
 			"name" : "06_ch13",
 			"component" : A6_CH13
 		},
 		{
 			"path" : "/06_ch14",
 			"name" : "06_ch14",
 			"component" : A6_CH14
 		},
 		{
 			"path" : "/06_ch15",
 			"name" : "06_ch15",
 			"component" : A6_CH15
 		},
 		{
 			"path" : "/06_ch16",
 			"name" : "06_ch16",
 			"component" : A6_CH16
 		},
 		{
 			"path" : "/07_ch21",
 			"name" : "07_ch21",
 			"component" : A7_CH21
 		},
 		{
 			"path" : "/08_ch31",
 			"name" : "08_ch31",
 			"component" : A8_CH31
 		},
 		{
 			"path" : "/08_ch32",
 			"name" : "08_ch32",
 			"component" : A8_CH32
 		},
 		{
 			"path" : "/08_ch33",
 			"name" : "08_ch33",
 			"component" : A8_CH33
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js